import { FormattedMessage, useIntl } from 'react-intl';

import { FormField } from '../../../../forms/formField/index';
import { numbersOnly } from '../../../../forms/helpers/normalisers';
import messages from '../CompanyDetails.messages';

const TurnoverQuestion = (props) => {
    const intl = useIntl();
    const { onChange } = props;

    return (
        <FormField
            label={<FormattedMessage {...messages.lastTwelveMonthsTurnover} />}
            className="fs-exclude"
            name="annualTurnover"
            id="annualTurnover"
            onChangeHandler={onChange}
            normalize={numbersOnly}
            format={(value) => (value ? intl.formatNumber(value) : '')}
            data-testid="annual-turnover-field"
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default TurnoverQuestion;
